module.exports = __webpack_public_path__ + "img/logo-livecities1.81da0d5b.png";